<!--
 * @Description: 惠税直达服务专区 - 税费政策库
 * @Author: LXG
 * @Date: 2021-08-17
 * @Editors: LXG
 * @LastEditTime: 2021-08-21
-->
<template>
  <div class="sf-policy-library">
    <div class="left">
      <!-- <FilterGroup class="pad-tb-1 pad-rl-2" @change="chooseChange">
        <FilterItem
          v-model="searchInfo.data.type"
          label="我要找："
          :list="cpu_typeList"
          valueKey="id"
          labelKey="labelname"
          @change="chang"
        ></FilterItem>
        <FilterItem
          class="search-tag"
          :needAll="false"
          v-show="searchInfo.data.type"
        >
          <div
            v-for="(item, index) in cpu_tagList"
            :key="index"
            class="bord-r-1 tag-item"
            :class="{
              'tag--active': item.choose == 1,
            }"
            @click="changeTag(item, index)"
          >
            {{ item.labelname }}
          </div>
        </FilterItem>
        <FilterItem
          class="search-tag"
          :needAll="false"
          v-if="childrenData.length != 0"
        >
          <div
            v-for="(item, index) in childrenData"
            :key="index"
            class="bord-r-1 tag-item"
            :class="{
              'tag--active': item.choose == 1,
            }"
            @click="changeTag(item, index)"
          >
            {{ item.labelname }}
          </div>
        </FilterItem>
      </FilterGroup> -->
      <el-collapse v-model="activeNames">
        <el-collapse-item :name="0">
            <template slot="title">
                  <div class="item" @click="clickLi(0)">政策标签</div>
            </template>
            <div class="sub_item">
               <el-tree
                  :data="treeData"
                  :default-expand-all="false"
                  node-key="labelcode"
                  ref="tree"
                  :check-on-click-node="true"
                  :props="defaultProps"
                  @check="treeCheck"
                  :render-content="renderContent"
                  :default-checked-keys="checkList"
                  :expand-on-click-node="false"
              >
              </el-tree>
            </div>
        </el-collapse-item>
      </el-collapse>

    </div>
    <div class="wrap-content">
      <div class="pad-tb-1 pad-rl-2 content-header">
        <!--        <div>
          <el-button
            class="search-release"
            :class="{
              'search-release&#45;&#45;desc': searchInfo.data.releaseTime == 1,
            }"
            type="text"
            @click="changeRelease"
          >
            <span>印发时间</span>
            <i class="el-icon-top"></i>
          </el-button>
           <el-checkbox
            class="search-calculate"
            v-model="searchInfo.data.canCalculate"
            @change="changeCalculate"
            >仅显示可计算的政策</el-checkbox
          >
        </div>-->
        <span style="margin-right: 150px" class="result">
          <el-button class="computeBtn" round @click="groupTimeGX()"
            >按更新时间排序</el-button
          >
          <el-button class="computeBtn" round @click="groupTimeFB()"
            >按发布时间排序</el-button
          >
        </span>
        <div class="searchbar">
          <FormInput
            v-model="searchInfo.data.keywords"
            style="width: 300px !importatnt"
          ></FormInput>
          <el-button size="medium" type="primary" @click="changeKeywords"
            >搜索
          </el-button>
          <el-button size="medium" type="primary" @click="showSearch">高级搜索</el-button>
        </div>
      </div>
      <div class="content-body">
        <div>
          <div
            v-for="(item, index) in listData"
            :key="index"
            class="pad-1 bord-r-1 marg-tb-1 marg-rl-2 policy-item"
          >
            <div class="pad-rl-1 bord-r-1 policy-zcfs">
              <span
                v-for="(proj, index) in cpu_policyProjectList(item)"
                :key="index"
                v-show="proj.zcname"
                class="zcfs-item"
                >{{ proj.zcname }}</span
              >
              <!-- {{getDictLabel('sq_policy_zjlx', item.zcfs)}} -->
            </div>
            <h3 class="policy-name" @click="toPolicyDetail(item)">
              {{ item.name }}
            </h3>
            <div class="policy-content">{{ item.content1.substr(0, 200) }}</div>
            <div class="policy-infos">
              <div
                v-for="(info, index) in policyInfos"
                :key="index"
                class="info-item"
                :style="{ width: info.width }"
              >
                <label class="info-label">{{ info.label }}：</label>
                <div class="info-value">
                  <template v-if="info.valueFormatter"
                    >{{ info.valueFormatter(item) }}
                  </template>
                  <template v-else>{{ item[info.valueKey] }}</template>
                </div>
              </div>
            </div>
            <!-- <div class="policy_footer"> -->
              <!-- <div style="float: right; display: flex">
                <a
                  href="https://12366.chinatax.gov.cn/xiaohui/"
                  target="_blank"
                >
                  <span class="online"><i></i>在线咨询</span>
                </a>
                <span class="yuyue" @click="toAdvisory(item)"
                  ><i></i>预约专家团队咨询</span
                >
              </div> -->
              <!--              <div class="policy-tag">
                              <label>标签：</label>
                              <div style="flex: 1">
                                <span
                                  v-for="(tag, index) in item.policyClassificationValue"
                                  :key="index"
                                  class="marg-rl-2"
                                  >{{ tag }}</span
                                >
                              </div>
                            </div>-->
            <!-- </div> -->
          </div>
        </div>
        <el-pagination
          class="marg-tb-2"
          style="text-align: center"
          background
          layout="prev,pager,next,total,jumper"
          :current-page.sync="pageInfo.page"
          :page-size.sync="pageInfo.size"
          :total="pageInfo.total"
          @current-change="changePage"
        ></el-pagination>
      </div>
    </div>

    <el-dialog title="高级搜索" :visible.sync="dgVisible" width="50%">
      <el-form :model="form" ref="ruleForm" label-width="87px">
        <el-row>
          <el-col :span="20" :offset="1">
            <el-form-item label="政策标题" prop="policyName">
              <el-input v-model="form.name" placeholder="请输入政策标题" style="position:relative;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10" :offset="1">
            <el-form-item label="发文字号" prop="fwzh" >
              <el-input v-model="form.fwzh" placeholder="请输入发文字号" style="position:relative;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10" :offset="1">
            <el-form-item label="主管部门" prop="deptId" >
              <el-select filterable v-model="form.deptId" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.deptId"
                  :label="item.deptName"
                  :value="item.deptId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10" :offset="1">
            <el-form-item label="发布时间:" prop="publictime">
              <el-date-picker
                v-model="form.publictime"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="10" :offset="1">
            <el-form-item label="政策级别" prop="areaid" >
              <el-select filterable v-model="form.areaid" placeholder="请选择">
                <el-option
                  v-for="item in areaIds"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col class="text-center" :span="24">
            <el-row>
              <el-col class="text-center" :span="5" :offset="6">
                <el-button @click="reset" style="width:50%">重 置</el-button>
              </el-col>
              <el-col class="text-center" :span="5" :offset="2">
                <el-button type="primary" @click="searchList" style="width:50%">搜 索</el-button>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  // FilterGroup,
  // FilterItem,
} from "@/views/findList/components/filter/index.js";
import { FormInput } from "@/components/form/index.js";
import $tjCommonDialog from "@/components/tj-common-dialog/index.js";
import TjCommonDialog from "@/components/tj-common-dialog/TjCommonDialog";

export default {
  name: "SfPolicyLibrary",
  components: {
    // FilterGroup,
    // FilterItem,
    FormInput,
  },
  filters: {},
  props: {},
  data() {
    return {
      activeNames: [0],
      checkList:[],
      treeData:[],
       defaultProps: {
        children: "children",
        label: "labelname",
      },
      childrenData: [],
      searchInfo: {
        data: {
          iam: "", // 我是
          type: "", // 我要找(税类型)
          tag: [], // 标签
          flag: [], // 标签变红
          keywords: "", // 关键字
          releaseTime: 1, // 印发时间排序
          canCalculate: false, // 是否可计算
        },
        typeTagData: [], // 类型及标签数据
        typeTagData2: [], // 类型及标签数据（点不限使用）
      },
      // 政策列表数据
      listData: [],
      policyInfos: [
        {
          width: "200px",
          label: "政策等级",
          valueFormatter: (item) => {
            if (!item.areaid) return "--";
            return this.getDictLabel("areaLevel", item.areaid);
          },
        },
        // {
        //     width: '400px',
        //     label: '发文单位',
        //     valueKey: 'fbjg',
        // },
        {
          label: "发布日期",
          valueKey: "publictime",
        },
      ],
      pageInfo: {
        page: 1,
        size: 5,
        total: 0,
      },
      tempParam: [],
      sortByType: 1, //  0 是更新时间排序    1是发布时间排序
      dgVisible:false,
      form:{},
      options:[],
      areaIds: [{
        value: '0',
        label: '国家'
      }, {
        value: '1',
        label: '省级'
      }, {
        value: '2',
        label: '市级'
      }],
    };
  },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      getDictList: "dictionary/getDictList",
      getDictLabel: "dictionary/getDictLabel",
    }),
    /**
     * @description: 税类型列表
     * @return {Array}
     */
    cpu_typeList() {
      return this.searchInfo.typeTagData.filter((cv) => cv.parentId == "0");
    },
    /**
     * @description: 税类型下的标签列表
     * @return {Array}
     */
    cpu_tagList() {
      // 标签的parentId为父类的id
      let arr = this.searchInfo.typeTagData.filter((cv) => cv.parentId == "0");
      if (!this.searchInfo.data.type) return arr;
      let temp = [];
      arr.forEach((item) => {
        if (item.id == this.searchInfo.data.type) {
          temp = item.children;
        }
      });
      // this.getTreeParentChilds(arr,this.dataId)
      return temp;
    },
    cpu_policyProjectList() {
      return function (policy) {
        return policy.cfgPermitItemInfoList || [];
      };
    },
  },
  methods: {
    renderContent(h,{node,data}){
      //
      if(this.checkList.indexOf(node.data.labelcode)!=-1){
        return (
          <span class="checkedStyle">{data.labelname}</span>
        )
      }else {
        return (
          <span style="font-size:18px;">{data.labelname}</span>
        )
      }
      // let arr = this.treeData
    },
    // 点击树形标签
    treeCheck(checkedNodes, checkedKeys) {
      this.searchInfo.data.tag = [];
      checkedKeys.checkedNodes.forEach((item) => {
        this.searchInfo.data.tag.push(item.labelcode);
      });
      this.checkList = checkedKeys.checkedKeys;
      //this.renderContent();
      this.queryListData();
    },
    chooseChange(val1, val2) {
      if (val1 == "我要找：") {
        this.childrenData = [];
        this.searchInfo.data.tag = [];
      }
      // if(this.searchInfo.data.type=""){
      //   this.queryListData()
      // }
    },

    chang(val) {
      if (!val) {
        //点击不限
        this.searchInfo.data.tag = [];
        this.queryListData();
      } else {
        this.tempParam = [];
        this.searchInfo.typeTagData.forEach((item) => {
          if (item.id == val) {
            this.setJieDian(item);
            item.choose = "1";
            this.tempParam.push(item.labelcode);
            this.setLabel(item);
            this.searchInfo.data.tag = this.tempParam;
          } else {
            item.choose = "0";
          }
        });

        this.queryListData();
      }
    },

    /**
     * 将该节点的子节点放入参数中
     */
    setLabel(val) {
      if (val.children && val.children.length > 0) {
        val.children.forEach((item) => {
          this.tempParam.push(item.labelcode);
          this.setLabel(item);
        });
      }
    },

    checkChildren(arr) {
      // 判断子节点是否有1
      arr = arr.children;
      let result = "0";
      arr.forEach((item) => {
        if (item.choose == "1") {
          result = "1";
          return result;
        }
      });
      return result;
    },

    setJieDian(arr) {
      // 将子节点全部变成0
      arr.children.forEach((item) => {
        item.choose = "0";
        if (item.children.length > 0) {
          this.setJieDian(item);
        }
      });
    },

    dealChildren(arr) {
      // 传入一个对象
      let x = "0";
      if (arr.choose == "1") {
        if (arr.children.length > 0) {
          arr.children.forEach((item) => {
            if (item.choose == "1") {
              if (this.checkChildren(item) == "1") {
                // 如果子节点有1 则继续循环
                this.dealChildren(item);
              } else {
                // 否则 将当前节点以及子节点的值存入临时参数
                this.tempParam.push(item.labelcode); //当前节点
              }
              x = "1"; // 加父极标签
            }
          });
        }
        if (x == "0") {
          this.setLabel(arr); //其子节点
          this.tempParam.push(arr.labelcode);
        }
      }
    },

    /**
     * @description: 修改搜索条件 标签
     * @param {Object} item 项
     * @param {Number} index 下标
     */
    changeTag(item, index) {
      if (item.choose == "1") {
        item.choose = "0";
        this.setJieDian(item);
      } else {
        item.choose = "1";
      }
      this.tempParam = [];
      this.searchInfo.typeTagData.forEach((item0) => {
        // 此方法是二三级标签点击方法 不考虑第一级
        item0.children.forEach((item2) => {
          if (item2.choose == "1") {
            this.dealChildren(item2);
          }
        });
      });
      this.searchInfo.data.tag = this.tempParam;
      if (item.layer == "2") {
        this.childrenData = item.children;
        if (item.choose == "0") {
          this.childrenData = [];
        }
      }

      this.listData = [];
      this.pageInfo.total = 0;
      this.pageInfo.page = 1;
      this.queryListData();
    },
    /**
     * @description: 修改搜索条件 印发时间排序
     */
    changeRelease() {
      this.searchInfo.data.releaseTime = this.searchInfo.data.releaseTime ^ 1;

      this.listData = [];
      this.pageInfo.page = 1;
      this.queryListData();
    },
    /**
     * @description: 修改搜索条件 是否可计算
     */
    changeCalculate() {
      this.listData = [];
      this.pageInfo.total = 0;
      this.pageInfo.page = 1;
      this.queryListData();
    },
    /**
     * @description: 修改搜索条件 关键字
     */
    changeKeywords() {
      this.listData = [];
      this.pageInfo.total = 0;
      this.pageInfo.page = 1;
      this.queryListData();
    },

    /**
     * @description: 高级搜索
     */
    searchList() {
      this.listData = [];
      this.pageInfo.total = 0;
      this.pageInfo.page = 1;
      this.queryListData();
      this.dgVisible = false;
    },
    reset(){
      this.form = {};
    },
    /**
     * @description: 前往政策详情页面
     * @param {Object} policy 政策
     */
    toPolicyDetail(policy) {
      window.sessionStorage.setItem("policyDetailData", JSON.stringify(policy));
      window.sessionStorage.setItem("flag", false);
      window.sessionStorage.setItem("status", false);
      // this.$router.push({
      //   name: "showPolicyDetail",
      //   query:{
      //     showSideNav:true,
      //   }
      // });
      let { href } = this.$router.resolve({
					name: "showPolicyDetail",
          query:{
            showSideNav:true,
          }
				});
		  window.open(href, "_blank");
    },
    /**
     * @description: 前往政策咨询页面
     * @param {Object} policy 政策
     */
    toAdvisory(policy) {
      // window.sessionStorage.setItem('policyDetailData', JSON.stringify(policy))
      // const { href } = this.$router.resolve({
      //     name: 'policyAdvisory',
      //     query: {},
      // })
      // window.open(href, '_blank')

      $tjCommonDialog.init({
        width: "400px",
        showClose: true,
        contentComponent: () => import("./ExpertAdvisory"),
      });
    },
    /**
     * @description: 切换页码
     * @param {Number} page 页码
     */
    changePage(page) {
      this.listData = [];
      this.queryListData();

      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    /**
     * @description: 查询税类型及标签
     */
    queryTypeAndTag() {
      // let url = `/label/warehouse/list?industryid=${window.encodeURI(
      //   "001003025"
      // )}`;

      let params = {
        industryid: "001003025002019",//税务局
        /*industryid: "001003025002015",//人社局*/
        /*industryid: "001003025",*/
        //isAll: true,
      };
      let url = `/label/warehouse/list`;
      this.$httpApi.get(url, params).then((res) => {
        if (res.code == 200) {
          this.treeData = res.data || [];
          let arr = this.flatTree(res.data)
        }
      });
    },
    flatTree(data){
      let arr = [];
      for(let i=0;i<data.length;i++){
        arr.push(data[i].labelcode);
        // if(data[i].children&&data[i].children.length!=0){
        //   return this.flatTree(data[i].children);
        // }
      }
      return arr;
    },
    /**
     * @description: 查询政策列表
     */
    queryListData() {
      let url = `/sqzd/policy/policyInfoList?pageNum=${this.pageInfo.page}&pageSize=${this.pageInfo.size}`;
      // let url = '/elastic/search/sq-policy'
      let params = {
        // fbjg: "国家税务总局信阳市税务局",
        /*deptId: "001003025002015",*/
        deptId: "001003025002019",
        remark: this.searchInfo.data.tag.join(","),
        // orderBy: this.searchInfo.data.releaseTime == 1 ? "desc" : "asc",
        name: this.searchInfo.data.keywords,
        orderBy: this.sortByType,
      };
      let par = {};
      Object.assign(par,params,this.form)
      if(this.form.publictime){
        par.startPublictime = this.form.publictime[0];
        par.endPublictime = this.form.publictime[1];
        delete par.publictime;
      }
      this.$httpApi.post(url, par).then((res) => {
        // && !!res.rows.length
        if (res.rows) {
          this.listData = res.rows;
          this.pageInfo.total = res.total;
        }
      });
    },

    /**
     * 高级搜索
     */
    showSearch(){
      this.dgVisible = true;
    },

    //按照发布时间
    groupTimeFB() {
      this.sortByType = 1;
      this.queryListData();
    },
    //按照更新时间
    groupTimeGX() {
      this.sortByType = 0;
      this.queryListData();
    },
  },
  watch: {},
  created() {
    this.queryTypeAndTag();
    this.queryListData();
    this.$store.dispatch("dictionary/commonSetDic", {
      types: [
        "tax_ws", // 我是(哈哈?)
        // 'tax_wyz', // 我要找(哈哈?)
        "sq_policy_zjlx", // 扶持方式(支持方式)
      ],
    });
  },
  mounted() {
    let url = '/dev-api/system/dept/zList';
    this.$httpApi.get(url, {priority:"1"}).then((res) => {
      // && !!res.rows.length
      if (res.data) {
        this.options = res.data;
      }
    });
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .el-collapse-item__arrow {
    display: none;
  }
}
::v-deep .checkedStyle  {
  font-size:18px;
  color:red;
  display:inline-block;
  width:100%;
  height:100%;
  //background:#85D4E6;
}
::v-deep {
  .el-input--medium {
    width: 300px !important;
  }
}

::v-deep .filter-group {
  margin-bottom: 2rem;

  .filterItem-label {
    font-size: 1rem;
    white-space: pre;
  }
}

::v-deep .filter-item {
  padding-top: 10px;
  padding-bottom: 10px;

  &.search-tag {
    .filterItem-content {
      gap: 1rem;
    }

    .tag-item {
      padding: 0.1rem 0.5rem;
      border: 1px solid #666666;
      cursor: pointer;

      &:hover {
        color: #e0240a;
      }

      &.tag--active {
        border-color: #e0240a;
        color: #ffffff;
        background-color: #e0240a;
      }
    }
  }
}
.sf-policy-library {
  padding-top: 50px;
  display: flex;
  justify-content: space-around;
  .left {
    width: 20%;
    margin-top: -6px;
    ::v-deep .filterItem-label {
      display: none;
    }
    .item {
      width: 100%;
      line-height: 20px;
      padding: 15px 0;
      padding-left: 38px;
      color: #fff;
      border-bottom: 1px solid #fff;
      margin-bottom: 5px;
      font-size: 18px;
      background: #1472FF url("~@/assets/images/showPolicy/xwdt_liOn.png") no-repeat
        16px center;
      cursor: pointer;
      transition: all 0.3s;
    }
    .sub_item {
      height: 912px;
      margin: 5px 0;
      background: #f3f3f38c;
      overflow-y: auto;
      overflow-x: auto;
      .el-tree {
        background: #EDF3F9;
        ::v-deep .el-icon-caret-right:before {
          // 未展开
          content: "\e783";
          font-size: 18px;
        }
        ::v-deep .expanded:before {
          // 展开
          content: "\e781";
          font-size: 18px;
        }
        ::v-deep .expanded {
          // 展开不旋转
          -webkit-transform: rotate(0deg);
          transform: rotate(0deg);
        }
      }
      ::v-deep .el-tree-node__label {
        font-size: 1.125rem;
        color: #000;
        //background: #999;
      }
      ::v-deep .el-tree-node__content:hover {
        font-size: 1.125rem;
        color: #000;
        //background: #999;
      }
      // ::v-deep .el-checkbox-button__inner {
      //   border: none !important;
      //   border-radius: 20px !important;
      //   background: none !important;
      //   color:#fff;
      // }
      // background-color: red;
      ::v-deep .el-input__inner {
        border: none;
        color: #333 !important;
      }
      ::v-deep .el-button {
        border: none;
        font-size: 18px;
      }
      ::v-deep .el-button:hover,
      ::v-deep .el-button:active {
        color: red;
        background-color: #fff;
      }
    }
    .sub_item::-webkit-scrollbar {
      display: none;
    }
  }
  .wrap-content {
    width: 78%;
    background-color: #ffffff;
    margin-top: -20px;
  }
}
.before {
  height: 10vh;
  line-height: 10vh;
  text-align: center;
  font-size: 1.2rem;
  color: rgba($col-theme, 0.5);
  background-color: #ffffff;
}

.content-header {
  display: -webkit-flex;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #1472FF;
}

.search-release {
  font-size: 1rem;
  color: $col-theme;

  .el-icon-bottom {
    font-weight: bold;
  }

  &.search-release--desc .el-icon-top {
    transform: rotate(180deg);
  }
}

::v-deep .search-calculate {
  margin-left: 2rem;
  font-size: 1rem;

  .el-checkbox__label {
    line-height: 1rem;
    font-size: 1rem;
  }
}

.searchbar {
  display: -webkit-flex;
  display: flex;
  align-items: center;

  ::v-deep .form-input .el-input__inner {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  .el-button {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}

.content-body {
  min-height: 5rem;
  overflow: auto;
}

.policy-item {
  border: 1px solid rgba($col-theme, 0.5);
  -webkit-transition: all 0.4s ease 0s;
  -moz-transition: all 0.4s ease 0s;
  -o-transition: all 0.4s ease 0s;
  transition: all 0.4s ease 0s;

  .policy-zcfs {
    .zcfs-item {
      display: inline-block;
      border: 1px solid $col-theme;
      color: $col-theme;
    }
  }

  .policy-name {
    color: #000000;
    cursor: pointer;

    &:hover {
      color: $col-theme;
    }
  }

  .policy-content {
    color: #000000;
  }

  .policy-infos {
    display: -webkit-flex;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin-top: 5px;

    .info-item {
      display: -webkit-flex;
      display: flex;
      align-items: flex-start;

      .info-value {
        flex: 1;
        min-width: 0;
      }
    }
  }

  .policy_footer {
    padding-top: 5px;
    padding-bottom: 5px;
    border-top: 1px solid rgba($col-theme, 0.5);
    margin-top: 5px;
    overflow: auto;
  }

  .online,
  .yuyue {
    display: flex;
    align-items: center;
    color: red;
    margin-right: 10px;
    cursor: pointer;
  }

  .online i,
  .yuyue i {
    display: inline-block;
    width: 24px;
    height: 24px;
    background-position: center;
  }

  .online i {
    background-image: url("~@/assets/images/online.png");
  }

  .yuyue i {
    background-image: url("~@/assets/images/yuyue.png");
  }

  .policy-tag {
    display: -webkit-flex;
    display: flex;
    align-items: flex-start;
  }

  &:hover {
    box-shadow: 0px 1px 5px 2px rgba(0, 0, 0, 0.1);
    -webkit-transform: translateY(-2px);
    -moz-transform: translateY(-2px);
    -o-transform: translateY(-2px);
    -ms-transform: translateY(-2px);
    transform: translateY(-2px);
  }
  .result {
    font-size: 18px;
    position: absolute;
    right: 36px;
  }
}
</style>
